import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Link } from 'react-router-dom';

import Header from './components/Header/Header';
import SubscriptionSection from './components/SubscriptionSection/SubscriptionSection';

import MainContent from './components/MainContent/MainContent';
import Footer from './components/Footer/Footer';
import AlertDetails from './components/AlertDetails/AlertDetails';
import OverviewList from './components/Overview/OverviewList';
import ScanInterface from './components/Overview/ScanInterface';
import DeployExploitInterface from './components/Overview/DeployExploitInterface';
import DataExfiltrationInterface from './components/Overview/DataExfiltrationInterface';
import BlogDetailPage from './components/BlogSection/BlogDetailPage'; // Renamed from BlogDetailPage for consistency
import AllBlogsPage from './components/BlogSection/AllBlogsPage';
import ReportSection from './components/ReportSection/ReportSection'

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <SubscriptionSection />
             
              <MainContent />
            </>
          } />
          <Route path="/alerts/:alertId" element={<AlertDetails />} />
          <Route path='/Overview-List' element={<OverviewList/>} />
          <Route path='/scan' element={<ScanInterface/>} />  
          <Route path='/deploy' element={<DeployExploitInterface/>} /> 
          <Route path='/exfiltration' element={<DataExfiltrationInterface/>} /> 
          {/* FIX: Changed :ID to :id to match useParams destructuring */}
          <Route path="/blog/:id" element={<BlogDetailPage />} /> 
          <Route path='/blogs' element={<AllBlogsPage/>} /> 
          <Route path="/report" element={<ReportSection />} />

          {/* Fallback route for 404 - Highly Recommended */}
          <Route path="*" element={
            <div className="min-h-screen bg-gradient-to-br from-[#0a0a1a] via-[#1a0a2a] to-[#0a0a1a] text-white font-mono flex flex-col items-center justify-center p-4">
              <h1 className="text-4xl text-red-400 mb-4">404 - Page Not Found</h1>
              <p className="text-lg text-gray-300 mb-6">The intelligence report you are looking for does not exist.</p>
              <Link to="/" className="group inline-flex items-center gap-3 px-8 py-3 bg-gradient-to-r from-[#00ffff] to-[#00aacc] text-black font-bold rounded-lg hover:from-[#00aacc] hover:to-[#00ffff] transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-[#00ffff]/50">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 17l-5-5m0 0l5-5m-5 5h12" />
                </svg>
                BACK TO HOME
              </Link>
            </div>
          } />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;